import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Noticias from '../views/noticias/General.vue'

Vue.use(VueRouter)

const News = {
    template: `<div>
  <h1>News</h1>
  <br><br>
  <router-view></router-view>
  </div>
  `
}

const routes = [{
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/nosotros',
        name: 'Nosotros',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Nosotros.vue')
    },
    {
        path: '/presidencia',
        name: 'Presidencia',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Presidencia.vue')
    },
    //{
    //    path: '/sala-plena',
    //    name: 'Sala Plena',
    //    component: () =>
    //        import ( /* webpackChunkName: "about" */ '../views/Misión.vue')
    //},
    {
        path: '/mision-vision',
        name: 'Misión',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Misión.vue')
    },
    {
        path: '/subsedes-zonasur',
        name: 'Zona Sur',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/subsedes/zonasur.vue')
    },
    {
        path: '/subsedes-zonanorte',
        name: 'Zona Norte',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/subsedes/zonanorte.vue')
    },
    {
        path: '/noticias',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/noticias/Content.vue'),
        children: [{
                path: '',
                name: 'Noticiass',
                component: Noticias,
            }, {
                path: ':id/:title',
                name: 'Noticia',

                component: () =>
                    import ( /* webpackChunkName: "about" */ '../views/noticias/Detalle.vue')
            },

        ],
    },
    {
        path: '/dej-alimentos',
        name: 'Depósitos Judiciales Electrónicos de alimentos',
        component: () =>
            import ( /* webpackChunkName: "dej_alimentos_consulta" */ '../views/dej_alimentos/Consulta.vue')
    },

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    }
})

const DEFAULT_TITLE = 'Corte Superior de Justicia de Puno';
router.afterEach((to, from) => {
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

export default router